<template>
  <div class="content">
  <p style="font-weight: 400;">本版发布日期：2026年7月14日</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">生效日期：2026年7月14日</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">财通证券股份有限公司（以下简称&ldquo;我司&rdquo;）深知个人信息对您的重要性，会尽力保护您的个人信息安全。我司致力于维护您对我司的信任，恪守以下原则保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、必要性原则、确保安全原则、公开透明原则。同时，我司承诺依法采取相应的安全保护措施来保护您的个人信息。</p>
<p style="font-weight: 400;">以下是本协议的摘要信息：</p>
<ul>
<li>我们收集的个人信息</li>
</ul>
<p style="font-weight: 400;">(1.1)&nbsp;必采信息（不提供无法使用核心业务）</p>
<ul>
<li>账号注册：<strong>手机号码、短信验证码</strong></li>
<li>证券监管留痕：<strong>IMEI/Android ID/IDFA/IDFV、MAC 地址、公网/内网 IP、端口号、实际使用手机号、操作系统版本、IMSI、ICCID、终端软件名称及版本</strong></li>
<li>交易登录：<strong>资金账号、信用账号、密码、短信验证码</strong></li>
</ul>
<p style="font-weight: 400;">(1.2)&nbsp;业务附加信息（拒绝仅影响对应功能）</p>
<ul>
<li>实名认证：<strong>姓名、机构名称、部门、职位、邮箱、名片或工牌照片</strong></li>
<li>预约：精确/粗略位置</li>
<li>消息推送：<strong>设备型号、系统版本、应用列表、网络状态、推送厂商 SDK 所需信息</strong></li>
<li>统计分析：<strong>崩溃日志、设备传感器、光线传感器、IP、运营商、屏幕分辨率</strong></li>
<li>系统权限与使用目的</li>
<li>电话/设备状态：读取设备标识</li>
<li>位置：最近营业部</li>
<li>相机：上传认证资料</li>
<li>通知：精选信息、系统公告</li>
<li>存储：日志缓存、文件保存</li>
<li>剪切板：快速定位资讯/活动页面</li>
<li>网络：Wi-Fi 与蜂窝数据，完成数据展示及更新</li>
<li>第三方 SDK/插件共享</li>
</ul>
<p style="font-weight: 400;">我们内置以下第三方组件，它们会按各自隐私政策自行采集设备标识、网络信息、应用列表，用于推送、一键登录、性能监测：</p>
<p style="font-weight: 400;">魅族推送、小米推送、华为推送、vivo 推送、OPPO 推送、个推、移动/联通/电信一键登录、极验、友盟、神策、Cordova。</p>
<p style="font-weight: 400;">除监管强制留痕数据外，上述 SDK 数据不经过我司服务器，第三方独立控制并负责其数据安全。</p>
<ul>
<li>是否用于精准营销</li>
</ul>
<p style="font-weight: 400;">我们承诺：不会利用您的个人信息进行定向广告或精准推荐。仅向您发送与账户相关的服务通知及合规必要的提醒。</p>
<ul>
<li>数据存储与期限</li>
</ul>
<p style="font-weight: 400;">存储地点：中华人民共和国境内</p>
<p style="font-weight: 400;">保存期限：证券法规要求 &ge;20 年；其他数据在您注销账号后 15 个工作日内删除或匿名化</p>
<ul>
<li>如何行使您的权利</li>
</ul>
<p style="font-weight: 400;">访问、更正、删除：APP 内&ldquo;我的-设置-账户管理&rdquo;或拨打 95336</p>
<p style="font-weight: 400;">撤回授权：手机系统设置 &gt; 应用权限管理</p>
<p style="font-weight: 400;">注销账号：APP 内&ldquo;我的-设置-账户注销&rdquo;，提交后 15 个工作日内完成删除/匿名化</p>
<p style="font-weight: 400;">获取个人信息副本：拨打 95336 验证身份后提供</p>
<ul>
<li>未成年人</li>
</ul>
<p style="font-weight: 400;"><strong>本APP不面向未满18周岁的未成年人</strong>，如误操作使用本APP，请联系财通证券进行数据删除。</p>
<ul>
<li>联系我们</li>
</ul>
<p style="font-weight: 400;">财通证券股份有限公司</p>
<p style="font-weight: 400;">地址：浙江省杭州市西湖区天目山路 198 号财通双冠大厦</p>
<p style="font-weight: 400;">客服热线：95336&emsp;投诉邮箱：<a href="mailto:95336@ctsec.com"><u>95336@ctsec.com</u></a></p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;"><strong>请您在注册前，仔细阅读并确认《隐私政策》</strong>。 本《隐私政策》将帮助您了解以下内容 ：</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">1.我司如何收集和使用您的个人信息</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">2.我司如何使用Cookie和同类技术</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">3.关于存储和对外提供您的个人信息</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">4.我司如何保护您的个人信息</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">5.您控制个人信息的权利</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">6.我们如何保护未成年人的信息</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">7.本政策如何更新</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">8.如何联系我司</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;"><strong>一、我司如何收集和使用您的个人信息</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。个人信息包括姓名、出生日期、身份证件号码、个人生物识别信息、</strong><strong>通信联系</strong><strong>方式、住址、账户信息、财产状况、行踪轨迹。其中一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇的信息为个人敏感信息，主要包括身份证件号码、个人生物识别信息、银行账号、征信信息、财产信息、 交易信息、行踪轨迹。</strong></p>
<p style="font-weight: 400;"><strong>（一）我司收集和使用个人信息的原则</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>我司收集使用您的个人信息将遵循合法、正当、必要</strong><strong>、诚信</strong><strong>的原则，按照法律法规要求以及业务需要收集您的个人信息，不会收集与业务无关的信息或采取不正当方式收集信息。</strong><strong>我司不会</strong><strong>利用用户个人信息做定向</strong><strong>推荐，不会基于用户个人信息做个性化推送或展示。</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>您在首次使用APP时，弹窗提醒您阅读并充分理解《财运亨通隐私政策》，如您选择&ldquo;同意并继续&rdquo;，则代表您同意我们根据使用需要处理您的敏感个人信息，</strong><strong>如您拒绝提供，</strong><strong>我司可能无法</strong><strong>完成某些身份验证相关功能</strong><strong>，</strong><strong>导致您无法使用本APP</strong><strong>。</strong></p>
<p style="font-weight: 400;"><strong>（二）我司收集和使用个人信息的目的</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;">为了遵守中国法律的规定，以及为了向您提供服务并保障您的账号安全与系统运行安全，我们会收集您在使用我们的服务的过程中产生的相关信息，包括：</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">1、手机号码注册</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">当您注册使用财运亨通APP时，<strong>根据法律法规中关于网络实名制要求，您需要输入手机号码，我们将通过发送短信验证码来验证您的身份是否有效。</strong>如您拒绝提供手机号码验证，将会影响您使用我司软件。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">2、设备或应用信息</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">根据监管要求，证券金融类交易行为需要报送用户登录当前设备的IP、MAC、IMEI、UUID、IDFA、IDFV、手机号、Android ID作为硬件留痕信息。因此，为保障用户账户及交易安全，我们会在用户执行相关操作时，对设备或应用信息，包括您的移动设备、网页浏览器或您用于接入我司服务的其他程序所提供的配置信息、您的IP地址、无线网络接入信息和您的移动设备所用的版本、硬件型号、设备MAC地址、操作系统类型、软件列表等唯一设备识别码（IMEI、Android ID、IDFA、IDFV、IDFA、OPENUDID、GUID、SIM卡IMSI信息在内的描述个人常用设备基本情况的信息）进行转发。即便在未登录状态下，也可以获得便捷流畅的体验，并同样可以进行阅读、查看的基础行为。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">除了产品的基本功能外，我们提供一些附加功能来实现业务功能，需要提供<strong>以下权限与信息</strong><strong>：设备</strong><strong>权限、位置信息、个人敏感信息</strong>。当您使用附加功能时，我们会取得相关权限的同意。您也可以在设备的设置功能中随时选择关闭部分或者全部权限，从而拒绝我们收集或提供相应的个人信息，也不会影响其他功能的使用。在不同设备中，权限显示方式及关闭方式可能有所不同，具体请参考设备及系统开发方说明或指引。<strong>前述信息包含您的敏感个人信息，如您不提供前述信息，可能无法使用附加功能服务，但不影响您使用我们提供的其他服务。</strong></p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">3、设备权限</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">在提供服务的过程中，可能需要您开通一些设备权限，我们会通过弹窗方式请求通知、WiFi及蜂窝数据的权限、手机存储、摄像头、定位信息；在您需要消息内容推送时，会主动提示您获取通知的权限；在您需要使用与访问网络时，会主动提示WiFi及蜂窝数据相关权限；在您需要通过摄像头拍照提交相关材料时，会主动提示摄像头的权限；在您使用预约开户功能时，为了更方便地给您推荐我司服务，我们会让您开启定位权限；在您使用时为了方便拨打客户服务电话，我们会请求拨打电话的权限；在您使用时为了方便定位到您通过文本复制的文章和活动页面，我们会请求读取剪切板的权限。我们会请求安装程序包的权限，方便您快速进行应用程序升级。除此之外，苹果系统还有后台APP刷新机制、Siri与搜索的权限，对于此类权限，我们无法收集相关个人信息，您可以查阅苹果公司的相关协议后选择使用与否。</p>
<p style="font-weight: 400;">前述信息可能包含您的敏感个人信息，如您不提供前述信息，可能无法完整使用我们提供的服务。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">4、我们接入的第三方</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">为了使您能够接收信息推送、在第三方平台分享信息以及运营统计的需要，我们应用接入了第三方sdk或服务，具体第三方信息如下：</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">魅族推送SDK</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">应用场景描述：推送信息</p>
<p style="font-weight: 400;">收集的个人信息：访问网络、获取网络信息状态、获取WIFI状态、读取手机状态、写存储空间、未知应用安装权限、允许应用开启前台服务</p>
<p style="font-weight: 400;">信息类型：个人常用设备信息</p>
<p style="font-weight: 400;">共享方式：SDK本机采集</p>
<p style="font-weight: 400;">使用目的：让魅族设备能够收到推送消息</p>
<p style="font-weight: 400;">第三方机构名称：魅族科技有限公司</p>
<p style="font-weight: 400;">隐私协议链接：https://i.flyme.cn/privacy</p>
<p style="font-weight: 400;">官网链接：http://open.flyme.cn/</p>
<p style="font-weight: 400;">联系方式：DPO@meizu.com</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">小米推送SDK</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">应用场景描述：推送信息</p>
<p style="font-weight: 400;">收集的个人信息：访问网络、获取网络信息状态、获取WIFI状态、读取手机状态、写存储空间、未知应用安装权限、允许应用开启前台服务</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">信息类型：个人常用设备信息</p>
<p style="font-weight: 400;">共享方式：SDK本机采集</p>
<p style="font-weight: 400;">使用目的：让小米设备能够收到推送消息</p>
<p style="font-weight: 400;">第三方机构名称：北京小米移动软件有限公司</p>
<p style="font-weight: 400;">隐私协议链接：https://dev.mi.com/console/doc/detail?pId=1822</p>
<p style="font-weight: 400;">官网链接：https://dev.mi.com/console/</p>
<p style="font-weight: 400;">联系方式：<a href="https://privacy.mi.com/support">https://privacy.mi.com/support</a></p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">华为推送SDK</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">应用场景描述：推送信息</p>
<p style="font-weight: 400;">收集的个人信息：访问网络、获取网络信息状态、获取WIFI状态、读取手机状态、写存储空间、未知应用安装权限、允许应用开启前台服务</p>
<p style="font-weight: 400;">信息类型：个人常用设备信息</p>
<p style="font-weight: 400;">共享方式：SDK本机采集</p>
<p style="font-weight: 400;">使用目的：让华为设备能够收到推送消息</p>
<p style="font-weight: 400;">第三方机构名称：华为技术有限公司</p>
<p style="font-weight: 400;">隐私协议链接：https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050042177</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">官网链接：https://developer.huawei.com/consumer/cn/</p>
<p style="font-weight: 400;">联系方式：客服热线（950800）</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">vivo推送 SDK</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">应用场景描述：推送信息</p>
<p style="font-weight: 400;">收集的个人信息：访问网络、获取网络信息状态、获取WIFI状态、读取手机状态、写存储空间、未知应用安装权限、允许应用开启前台服务</p>
<p style="font-weight: 400;">信息类型：个人常用设备信息</p>
<p style="font-weight: 400;">共享方式：SDK本机采集</p>
<p style="font-weight: 400;">使用目的：让vivo设备能够收到推送消息</p>
<p style="font-weight: 400;">第三方机构名称：维沃移动通信有限公司</p>
<p style="font-weight: 400;">隐私协议链接：https://www.vivo.com.cn/about-vivo/privacy-policy</p>
<p style="font-weight: 400;">官网链接：https://push.vivo.com.cn</p>
<p style="font-weight: 400;">联系方式：<a href="mailto:privacy@vivo.com">privacy@vivo.com</a></p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">oppo推送 SDK</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">应用场景描述：推送信息</p>
<p style="font-weight: 400;">收集的个人信息：访问网络、获取网络信息状态、获取WIFI状态、读取手机状态、写存储空间、未知应用安装权限、允许应用开启前台服务</p>
<p style="font-weight: 400;">信息类型：个人常用设备信息</p>
<p style="font-weight: 400;">共享方式：SDK本机采集</p>
<p style="font-weight: 400;">使用目的：让oppo设备能够收到推送消息</p>
<p style="font-weight: 400;">第三方机构名称：广东欢太科技有限公司</p>
<p style="font-weight: 400;">隐私协议链接：https://open.oppomobile.com/wiki/doc#id=10288</p>
<p style="font-weight: 400;">官网链接：https://push.oppo.com/</p>
<p style="font-weight: 400;">联系方式：privacy@heytap.com</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">个推（每日互动股份有限公司）推送 SDK</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">应用场景描述：推送信息</p>
<p style="font-weight: 400;">收集的个人信息：设备平台、设备厂商及品牌、设备型号及系统版本、设备识别码、设备序列号，应用列表信息，网络信息，获取IP地址，读取手机状态、写存储空间、读取存储空间</p>
<p style="font-weight: 400;">信息类型：个人常用设备信息</p>
<p style="font-weight: 400;">共享方式：SDK本机采集</p>
<p style="font-weight: 400;">使用目的：让安卓设备能够收到推送</p>
<p style="font-weight: 400;">第三方机构名称：每日互动股份有限公司</p>
<p style="font-weight: 400;">隐私协议链接：http://docs.getui.com/privacy/</p>
<p style="font-weight: 400;">官网链接：https://www.getui.com/</p>
<p style="font-weight: 400;">联系方式：<a href="mailto:support@getui.com">support@getui.com</a></p>
<p style="font-weight: 400;">个推SDK补充说明：</p>
<ul>
<li>个推SDK引入了io.loBridg库用于实现对应功能；</li>
<li>个推SDK在前台静默、后台运行期间个推SDK出于消息推送实时性目的存在收集IP地址信息的行为。</li>
<li>个推SDK需要申请自启动权限，为确保用户能有效接收各类账号通知及订阅通知。</li>
</ul>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">移动 SDK</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">应用场景描述：一键登录</p>
<p style="font-weight: 400;">收集的个人信息：</p>
<p style="font-weight: 400;">Android：访问网络、网络信息状态、WIFI状态、修改WIFI状态、允许改变网络连接状态、读取手机状态</p>
<p style="font-weight: 400;">iOS：手机设备类型、手机操作系统、硬件厂商、国际移动设备识别码、运营商类型、网络类型、sim卡数量、国际移动用户识别码、网络地址、屏幕尺寸、屏幕分辨率</p>
<p style="font-weight: 400;">信息类型：个人常用设备信息</p>
<p style="font-weight: 400;">共享方式：SDK本机采集</p>
<p style="font-weight: 400;">使用目的：让移动用户可以一键登录账号</p>
<p style="font-weight: 400;">第三方机构名称：中移互联网有限公司</p>
<p style="font-weight: 400;">隐私协议链接：https://wap.cmpassport.com/resources/html/contract.html</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">官网链接：<a href="https://www.cmpassport.com/">https://www.cmpassport.com/</a></p>
<p style="font-weight: 400;">联系方式：10086</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">联通 SDK</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">应用场景描述：一键登录</p>
<p style="font-weight: 400;">收集的个人信息：</p>
<p style="font-weight: 400;">Android：访问网络、网络信息状态、WIFI状态、允许改变WIFI状态、允许改变网络连接状态、读取手机状态</p>
<p style="font-weight: 400;">iOS：网络类型、网络地址、运营商类型、本机手机号、国际移动用户标识码、sim卡数量、手机设备类型、手机操作系统、硬件厂商、屏幕尺寸、屏幕分辨率</p>
<p style="font-weight: 400;">信息类型：个人常用设备信息</p>
<p style="font-weight: 400;">共享方式：SDK本机采集</p>
<p style="font-weight: 400;">使用目的：让联通用户可以一键登录账号</p>
<p style="font-weight: 400;">第三方机构名称：中国联合网络通信有限公司</p>
<p style="font-weight: 400;">隐私协议链接：https://msv6.wosms.cn/html/oauth/privacy-policy.html</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">官网链接：<a href="http://www.chinaunicom.com.cn/index.html">http://www.chinaunicom.com.cn/index.html</a></p>
<p style="font-weight: 400;">联系方式：4000600611</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">电信 SDK</p>
<p style="font-weight: 400;">应用场景描述：一键登录</p>
<p style="font-weight: 400;">收集的个人信息：</p>
<p style="font-weight: 400;">Android：访问网络、网络信息状态、WIFI状态、允许改变WIFI状态、允许改变网络连接状态、读取手机状态</p>
<p style="font-weight: 400;">iOS：网络类型、网络地址、运营商类型、本机手机号、国际移动用户标识码、sim卡数量、手机设备类型、手机操作系统、硬件厂商、屏幕尺寸、屏幕分辨率</p>
<p style="font-weight: 400;">信息类型：个人常用设备信息</p>
<p style="font-weight: 400;">共享方式：SDK本机采集</p>
<p style="font-weight: 400;">使用目的：让电信用户可以一键登录账号</p>
<p style="font-weight: 400;">第三方机构名称：天翼数字生活科技有限公司</p>
<p style="font-weight: 400;">隐私协议链接：https://e.189.cn/sdk/agreement/detail.do?hidetop=true</p>
<p style="font-weight: 400;">官网地址：</p>
<p style="font-weight: 400;">http://id.189.cn/api?initialSrc=/html/api_detail_634.html</p>
<p style="font-weight: 400;">联系方式：id@189.cn</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">极验 SDK</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">应用场景描述：一键登录</p>
<p style="font-weight: 400;">收集的个人信息：</p>
<p style="font-weight: 400;">Android：访问网络、网络信息状态、WIFI状态、读取手机状态</p>
<p style="font-weight: 400;">iOS：网络类型、网络地址、运营商类型、本机手机号、国际移动用户标识码、sim卡数量、手机设备类型、手机操作系统、硬件厂商、屏幕尺寸、屏幕分辨率</p>
<p style="font-weight: 400;">信息类型：个人常用设备信息</p>
<p style="font-weight: 400;">共享方式：SDK本机采集</p>
<p style="font-weight: 400;">使用目的：提供用户手机号一键登录功能</p>
<p style="font-weight: 400;">第三方机构名称：武汉极意网络科技有限公司</p>
<p style="font-weight: 400;">隐私协议链接：https://www.geetest.com/Private</p>
<p style="font-weight: 400;">官网链接：<a href="https://www.geetest.com/">https://www.geetest.com</a></p>
<p style="font-weight: 400;">联系方式：service@geetest.com</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">友盟SDK</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">应用场景描述：统计分析、性能监测</p>
<p style="font-weight: 400;">收集的个人信息：IMEI、MAC地址、android_id、OPENUDID、GUID、GAID、OAID、SIM卡IMSI、网络状态，IDFA、电话状态、获取应用列表</p>
<p style="font-weight: 400;">信息类型：个人常用设备信息</p>
<p style="font-weight: 400;">共享方式：SDK本机采集</p>
<p style="font-weight: 400;">使用目的：应用崩溃信息统计</p>
<p style="font-weight: 400;">第三方机构名称： 友盟同欣（北京）科技有限公司</p>
<p style="font-weight: 400;">隐私协议链接：https://www.umeng.com/page/policy</p>
<p style="font-weight: 400;">官网链接：<a href="https://www.umeng.com/">https://www.umeng.com/</a></p>
<p style="font-weight: 400;">联系方式：Umeng_Legal@service.umeng.com</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">神策分析SDK</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">应用场景描述：统计分析、性能监测</p>
<p style="font-weight: 400;">收集的个人信息：IMEI、Android ID、IDFA、IDFV、OAID、UUID、Mac地址、IMSI信息、网络状态、位置信息、唯一应用程序编号，网络类型、运营商名称、IP &nbsp;地址、电话状态、获取应用列表、设备系统版本</p>
<p style="font-weight: 400;">信息类型：个人常用设备信息</p>
<p style="font-weight: 400;">共享方式：SDK本机采集</p>
<p style="font-weight: 400;">使用目的：基础数据收集与建模，驱动业务决策分析</p>
<p style="font-weight: 400;">第三方机构名称： 神策网络科技（北京）有限公司</p>
<p style="font-weight: 400;">隐私协议链接：https://www.sensorsdata.cn/compliance/privacy.html</p>
<p style="font-weight: 400;">官网链接：https://www.sensorsdata.cn</p>
<p style="font-weight: 400;">联系方式：<a href="mailto:mkt@sensorsdata.com"><u>mkt@sensorsdata.com</u></a></p>
<p style="font-weight: 400;">神策SDK补充说明：</p>
<ul>
<li>神策 SDK 为实现地理位置关联的个性化内容展示需申请<strong>位置信息</strong>权限，用户可自主选择是否授权；用户拒绝提供<strong>位置信息</strong>的，仅会致使基于地理位置的个性化内容推送功能无法生效，不会限制 APP 其他基础业务功能使用。</li>
</ul>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">Cordova</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">应用场景描述：系统框架层处理，统计分析</p>
<p style="font-weight: 400;">收集的个人信息：IMEI、IMSI、MAC地址、android_id、OPENUDID、GUID、ICCID、IP地址，IDFA、IDFV、获取应用包信息、读取外部存储</p>
<p style="font-weight: 400;">信息类型：个人常用设备信息</p>
<p style="font-weight: 400;">共享方式：本机采集</p>
<p style="font-weight: 400;">使用目的：APP系统底层页面加载框架</p>
<p style="font-weight: 400;">第三方机构名称： &nbsp;The Apache Software Foundation</p>
<p style="font-weight: 400;">官网链接：<a href="https://cordova.apache.org/">https://cordova.apache.org</a></p>
<p style="font-weight: 400;">隐私协议链接：无（开源代码）</p>
<p style="font-weight: 400;">联系方式：vp-privacy@apache.org</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">财运亨通APP基础组件</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">应用场景描述：基础业务功能</p>
<p style="font-weight: 400;">收集的个人信息：设备光线传感器</p>
<p style="font-weight: 400;">信息类型：个人常用设备信息</p>
<p style="font-weight: 400;">共享方式：本机采集</p>
<p style="font-weight: 400;">使用目的：用于判断设备使用场景是不是模拟器环境，保证信息安全。</p>
<p style="font-weight: 400;">第三方机构名称：财通证券股份有限公司</p>
<p style="font-weight: 400;">官网链接：<a href="https://www.ctsec.com/">https://www.ctsec.com</a></p>
<p style="font-weight: 400;">隐私协议地址：无</p>
<p style="font-weight: 400;">联系方式：95336</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">爱加密APP加固组件</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">应用场景描述：APP加固处理</p>
<p style="font-weight: 400;">收集的个人信息：无</p>
<p style="font-weight: 400;">信息类型：无</p>
<p style="font-weight: 400;">共享方式：无</p>
<p style="font-weight: 400;">使用目的：用于APP内部资源和相关组件的加固保护。</p>
<p style="font-weight: 400;">第三方机构名称：北京智游网安科技有限公司</p>
<p style="font-weight: 400;">官网链接：https://www.ijiami.cn</p>
<p style="font-weight: 400;">隐私协议地址：无</p>
<p style="font-weight: 400;">联系方式：4000-618-110</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;"><strong>（三）我司收集个人信息的方式</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;">1.我司为您提供服务时，您主动向我司提供的个人信息；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">2.我司为您提供服务过程中形成的与服务相关的信息；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">3.经您授权，向征信机构、信用管理公司、资信评估机 构或有关法律、监管机构许可的类似机构采集您的信用信息和行为信息；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">4.经您授权，向政府机构、司法机关及公共事业单位 （如人民银行、公安部、人力资源和社会保障部门、公积金管理中心、中国互联网金融协会等机构）采集与服务相关的必要信息，如您的工商信息、税务信息、诉讼信息、社保信息；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">5.经您授权，向合法留存您信息的自然人、法人以及其他组织收集与我司提供的服务相关的必要信息；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">6.经您许可的其他方式。</p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>（四）我司如何使用个人信息</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;">1.在向您提供我司的产品或服务，并为改进这些产品或服务时使用；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">2.在我司向您提供服务期间，您授权我司持续收集和使用您的信息。在您注销服务时，我司将停止收集您相关的个人信息，但我司会在业务资料归档、审计、监管协查领域继续使用此前收集的您的相关个人信息；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">3.为保证业务开展，或为防范风险，我司会对服务使用情况进行汇总、统计分析、加工，但这些信息不会包含您的任何身份识别信息；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">4.为了使您知悉使用我司产品或服务的情况或使您进一步了解我司服务，我司会向您发送服务状态通知以及相关产品或服务的商业性信息。如您不希望接受商业性信息，您有权退订，并要求我司停止为此项用途使用您的信息；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">5.将您的个人信息用于法律允许的其它用途。</p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>二、我司如何使用Cookie和同类技术</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>（一）Cookie</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;">为确保网站正常运转，我司会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，网站能够存储您的偏好或使用习惯数据。我司不会将Cookie用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie的功能。但如果您这么做，则需要在每一次访问我司的网站时更改用户设置。</p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>（</strong><strong>二</strong><strong>）</strong><strong>网站信标和像素标签</strong></p>
<p style="font-weight: 400;">除Cookie外，我司还会在网站上使用网站信标和像素标签等其他同类技术。例如，我司向您发送的电子邮件可能含有链接至我司网站内容的点击URL。如果您点击该链接，我司则会跟踪此次点击，帮助我司了解您的产品或服务偏好。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我司能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时退订。</p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>（</strong><strong>三</strong><strong>）</strong><strong>Do Not Track</strong><strong>（</strong><strong>请勿追踪</strong><strong>）</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;">很多网络浏览器均设有Do Not Track功 能，该功能可向网站发布Do Not Track请求。目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果您的浏览器启用了Do Not Track，那么我司的所有网站都会尊重您的选择。</p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>（四）日志信息</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;">在您访问我们的网站或使用我们的服务时，我们可能会收集日志信息，包括上文所述设备或应用信息、位置信息、点击流数据、应用情况以及您通过我们的服务分享的内容所包含的信息（元数据），用于互联网信息安全的监管要求，避免对用户的合法权益造成损害。其次，我们会在进行特殊处理且无法定位到特定用户后用于数据分析来分析产品服务。我司不会将其用于本政策所述目的之外的任何用途。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;"><strong>三、关于存储和对外提供您的个人信息</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>（</strong><strong>一</strong><strong>）</strong><strong>存储</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;">1.我司在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。</p>
<p style="font-weight: 400;">2.我司仅在法律法规要求的期限内，以及为实现本政策声明的目的所必须的期限内，确定单个用户数据的最长储存期限以及用户日志的储存期限。根据《中华人民共和国证券法》要求，我们将会按照规定的期限保存您的身份资料、交易记录，保存期限不得少于二十年。当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知您，在合理的期限内删除您的个人信息或进行匿名化处理，并立即停止收集个人信息的活动。</p>
<p style="font-weight: 400;">3.不存在个人信息的境外传输。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;"><strong>（</strong><strong>二</strong><strong>）</strong><strong>共享</strong></p>
<p style="font-weight: 400;">我们不会与任何第三方公司、组织和个人共享您的个人信息。以下情况除外：</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">1、在获取明确同意的情况下共享，获得您的同意后，我们会与其他方共享您的个人信息。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">2、我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">3、合作方共享：为了向您提供APP产品和服务，我们的某些服务将由合作方提供，我们可能会与合作方共享您的某些个人信息，以提供相关服务。我们仅会出于合法、正当、必要特定、明确的目的共享您的个人信息，并且只会共享提供我们服务所必要的个人信息并与合作方签署严格的保密协议。合作方无权将共享的个人信息用于其他任何用途。例如，我们可能会使用间接用户画像与合作方共享，并仅提供推广覆盖面和有效性的信息，不会提供您的个人身份信息。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">4、与我们的经营机构及关联公司的共享：您的个人信息可能会在我们的各经营机构及关联公司内部共享。我们只会共享必要的个人信息，且这种共享受本协议所声明目的的约束。一旦改变个人信息的处理目的，我们将会再次征求您的授权同意。共享个人信息的范围将根据具体业务情况而定，如向您发售、提供及营销财通及其关联公司的产品/服务，以及监管、维持、管理及操作有关产品/服务，可能在我们的各经营机构及关联公司内部共享您的个人身份信息及账户信息。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">5、监管留痕：2013年7月18日证监会发布《关于加强证券期货经营机构客户交易终端信息等客户信息管理的规定》、2020年3月20日中国证券投资者保护基金有限责任公司制定，并由证监会批准的《证券公司客户交易终端信息管理技术规范》要求。根据以上两个文件规定，证券交易必须要报送硬件信息到证券公司留痕，否则交易不合规。对应的业务功能与类型：交易委托、银证转账、账户登录、密码修改。采集的信息：移动终端根据操作系统的不同，主要分为iOS和Android两种类型。必采信息： iOS系统主要包括IDFA、IDFV、注册手机号码、实际使用手机号码、公网IP、公网IP端口号、MAC地址、内网IP。Android系统主要包括IMEI、注册手机号码、实际使用手机号码、公网IP、公网IP端口号、MAC地址、内网IP。其他系统主要包括：唯一识别码、注册手机号码、实际使用手机号码、公网IP、公网IP端口号、MAC地址、内网IP。选采信息：操作系统版本、IMSI、ICCID、交易终端软件名称及版本。</p>
<p style="font-weight: 400;">需要特别注意的是：交易留痕数据虽然是&ldquo;共享&rdquo;但我司并不享有该类数据的控制权，我们仅在交易留痕时为证券期货经营机构提供技术协助，并不会存储和使用该类数据。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;"><strong>&nbsp;</strong><strong>（</strong><strong>三</strong><strong>）</strong><strong>公开披露</strong></p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">我们不会公开披露您的个人信息。如在活动中披露中奖名单，我们会进行脱敏展示中奖手机号或用户名。但以下情况除外：</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">1、获得您的明确同意；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;"><strong>（四）根据相关法律法规及国家标准，在以下情形中，我们可能会依法共享、转让、公开披露您的个人信息无需征得您的同意：</strong></p>
<p style="font-weight: 400;">1、与国家安全、国防安全直接相关的；</p>
<p style="font-weight: 400;">2、与公共安全、公共卫生、重大公共利益直接相关的；</p>
<p style="font-weight: 400;">3、与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
<p style="font-weight: 400;">4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
<p style="font-weight: 400;">5、您自行向社会公众公开的个人信息；</p>
<p style="font-weight: 400;">6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;"><strong>四、我司如何保护您的个人信息</strong></p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（一）我司已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。我司会采取一切合理可行的措施，保护您的个人信息。例如：我司会使用加密技术确保数据的保密性；我司会使用受信赖的保护机制防止数据遭到恶意攻击；我司会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我司会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。<strong>针对敏感个人信息，在传输和存储时，我们将采用加密、权限控制、去标识化/匿名化等安全措施。</strong></p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;"><strong>（</strong><strong>二</strong><strong>）</strong><strong>请您理解，由于技术水平局限以及可能存在的恶意攻击，有可能出现我司无法合理预见、防范、避免、控制的意外情况。互联网并非绝对安全的环境，请使用复杂密码，协助我司保证您的账号安全。</strong></p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（三）如发生个人信息安全事件，我司将按照法律法规的要求，及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，或采取合理、有效的方式发布公告。同时，我司还将依据监管规定，上报个人信息安全事件处置情况。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;"><strong>（</strong><strong>四）</strong><strong>我司个人信息保护由我司系统运维部负责， 位于浙江省杭州市，联系方式95336。</strong></p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;"><strong>五、您控制个人信息的权利</strong></p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">按照中国相关的法律法规和监管规定，我司保障您对自己的个人信息行使以下权利：</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（一）访问、更正及更新您的个人信息</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">您有责任及时更新您的个人信息。您有权通过我司95336更正、更新您的个人信息，法律法规另有规定的除外。我司承诺15个工作日内更正、更新您的账户相关数据。</p>
<p style="font-weight: 400;">&nbsp;</p>
<ul>
<li>请求查阅或复制转移您的个人信息</li>
</ul>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">您有权通过我司95336等渠道请求查阅或复制转移您的个人信息，法律法规另有规定的除外。我司承诺15个工作日内向您提供您的账户相关数据，协助您查阅或复制转移。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（三）撤回隐私政策或删除您的个人信息</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">在以下情形中，您可通过我的－设置－账户注销提出撤回隐私政策和删除个人信息的请求</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">1、如果我司处理个人信息的行为违反法律法规；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">2、如果我司收集、使用您的个人信息，却未征得您的同意；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">3、如果我司处理个人信息的行为违反了与您的约定。</p>
<p style="font-weight: 400;">&nbsp;</p>
<ul>
<li>如果您不想继续使用我们的产品或服务，您有权撤回此前对您个人信息处理的同意，或您主动注销了手机账户，在注销后，除法律另有规定外我们将及时停止收集您个人信息的活动，您在财运亨通APP账户下的个人信息将进行删除或匿名化处理，且此前和财运亨通手机账户关联的相关产品和服务内容也将被删除。我司承诺15个工作日内删除您的账户相关数据，您可以通过我司客服热线95336与我们联系。</li>
<li>删除个人信息操作路径：我的－设置－账户注销提出，此外也可以通过我司客服热线95336与我们联系，提出您的要求。我司承诺15个工作日内删除您的账户相关数据。</li>
</ul>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">如您想撤回对部分个人信息处理的同意或改变授权范围，您可通过手机隐私权限设置管理您的设备相关应用信息/软件安装列表的信息收集。此等撤回部分信息可能影响该信息相关的功能，但不影响其他功能。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（四）撤回同意（撤销您的授权）</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">您可以通过设备系统权限设置或者通过财运亨通APP提供的联系方式要求撤销授权。您也可以通过注销账户的方式（<strong>我的</strong><strong>－</strong><strong>设置</strong><strong>－</strong><strong>账户注销</strong>），撤回我们继续收集您个人信息的全部授权。我司承诺15个工作日内删除您的账户相关数据，您可以通过我司客服热线95336与我们联系。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">请你理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定不会影响此前基于您的授权而开展的个人信息处理。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">如您需要撤回已同意的系统权限，可以按照如下方式进行操作：</p>
<p style="font-weight: 400;">您可以通过 我的 &gt; 设置 &gt; 系统权限申请和使用清单页面，对已同意的权限进行查看。</p>
<p style="font-weight: 400;">如您的设备是Android或者基于AOSP研发的系统软件，可以进入系统设置 &gt; 应用设置 &gt;找到财运亨通应用 &gt; 权限管理菜单 &gt; 对已同意的权限进行撤回和管理。</p>
<p style="font-weight: 400;">如您的设备是iOS系统软件，可以进入设置 &gt; 找到财运亨通应用 &gt; 对已同意的权限进行撤回和管理。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（五）注销账户</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">在以下情形中，您可通过我的－设置－账户注销提出注销账户的请求</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">1、如果我司处理个人信息的行为违反法律法规；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">2、如果我司收集、使用您的个人信息，却未征得您的同意；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">3、如果我司处理个人信息的行为违反了与您的约定。&nbsp;&nbsp;&nbsp;&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">4、如果您不想继续使用我们的产品或服务，或您主动注销了手机账户，在注销后，除法律另有规定外我们将及时停止收集您个人信息的活动，您在财运亨通APP账户下的个人信息将进行删除或匿名化处理，且此前和财运亨通手机账户关联的相关产品和服务内容也将被删除。我司承诺15个工作日内删除您的账户相关数据，您可以通过我司客服热线95336与我们联系。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">5、交易账号注销。如您需要注销交易账号，您可以通过我司统一客服热线95335与我们联系并提交您的交易账号注销诉求。销户业务提交申请后，流程完结通常需1-2个工作日。因涉及柜台业务，销户进度可联系所属营业部确认。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（六）个人信息副本获取</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">如您需要您的个人信息的副本，您可以通过我司客服热线95336与我们联系，在核实您的身份后，我们将向您提供您在我们的服务中的个人信息副本（包括基本资料、身份信息），但法律法规另有规定的或本政策另有约定的除外。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">（七）响应您的上述请求</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我司可能会先要求您验证自己的身份，然后再处理您的请求。请您理解，对于某些无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我司可能会予以拒绝。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;"><strong>尽管有上述约定，但按照法律法规要求， 如涉及以下情形我司将可能无法响应您的请求：</strong></p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">1、与国家安全、国防安全相关的；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">2、与公共安全、公共卫生、重大公共利益相关的；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">3、与犯罪侦查、起诉、审判和判决执行等相关的；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">4、有充分证据表明您存在主观恶意或滥用权利的；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">6、涉及我司商业秘密的。</p>
<p style="font-weight: 400;"><strong>六、未成年人使用本APP相关情况说明</strong></p>
<p style="font-weight: 400;">1、本指引所指未成年人是根据《中华人民共和国未成年人保护法》规定的未满18周岁的公民。<strong>根据中国法律法规，请您确认并承诺您是已满18周岁具有完全民事行为能力的成年人。</strong></p>
<p style="font-weight: 400;">2、我们非常重视保护未成年人的个人信息。财运亨通APP产品与服务主要适用对象为已满18周岁以自己的劳动收入为主要生活来源的具有完全民事行为能力的用户，请您确认并承诺您具有完全民事行为能力。本APP不面向未满18周岁的未成年人提供服务，如未成年人监护人发现误操作使用了财运亨通APP和相关服务，请联系我们进行对应数据删除操作，联系电话95336，我们会在14个工作日内进行删除相关个人信息。</p>
<p style="font-weight: 400;">3、如您的监护人不同意您按照本指引使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通过文中的联系方式通知我们，我们会设法尽快删除相关信息。</p>
<p style="font-weight: 400;">4、如您为未成年人的监护人，当您对该未成年人的信息处理存在疑问时，请通过文中的联系方式及时联系我们。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;"><strong>七</strong><strong>、本政策如何更新</strong></p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">财运亨通APP的所有服务均适用于本政策，除非相关服务已有独立的隐私权政策或相应的用户协议当中存在特殊约定。我们保留不时更新或修改本政策的权利。未经您明确同意，我们不会削减您按照本政策所应享有的权利。我们会通过推送通知、弹窗、官网公告等合理方式以便您能够及时了解本政策所做的任何变更（包括业务功能变更、使用目的变更等），并重新征得您的同意。若您不同意该变更可以停止使用财通证券移动应用产品和服务或通过95336客户服务热线、营业部现场反馈与我们联系。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">当本政策发生重大变更时，视具体情况，我们还会提供更为显著的通知，说明本政策具体变更内容。本政策所指的重大变更包括但不限于：</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">3、个人信息共享、转让或公开披露的主要对象发生变化；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">4、您参与个人信息处理方面的权利及其形式方式发生重大变化；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">5、我们负责客户数据保护及公民个人信息保护的责任部门、联络方式及投诉渠道发生变化时；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">6、个人信息安全影响评估报告表明存在高风险时。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;"><strong>八</strong><strong>、如何联系我司</strong><strong>和投诉举报渠道</strong></p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">如果您对本隐私政策有任何疑问、意见或建议，或认为您的个人信息权益受到侵害，需要处理个人信息安全相关投诉、举报，请联系我司客服热线95336。 我们会在15个工作日内处理您的诉求。</p>
<p style="font-weight: 400;">公司名称：财通证券股份有限公司</p>
<p style="font-weight: 400;">地址：中国浙江省杭州市西湖区天目山路198号财通双冠大厦</p>
<p style="font-weight: 400;">邮编：310007</p>
<p style="font-weight: 400;">全国统一服务及投诉举报处理热线：95336</p>
<p style="font-weight: 400;">投诉举报处理邮箱：<a href="mailto:95336@ctsec.com">95336@ctsec.com</a></p>
<p style="font-weight: 400;">投诉举报受理传真：0571-87823566</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">请您在同意之前仔细阅读本隐私政策，确保对其内容特别是字体加黑内容的含义及相应法律后果已全部知晓并充分理解。您同意并完成注册程序即视为您接受本隐私政策，我司将按照相关法律法规及本政策来合法使用和保护您的个人信息。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">附录1、《APP收集个人信息清单》</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;一、用户基本信息</p>
<p style="font-weight: 400;">&nbsp;</p>
<table style="font-weight: 400;">
<tbody>
<tr>
<td width="17.3800%">
<p><strong>服务类型</strong></p>
</td>
<td width="22.7600%">
<p><strong>服务描述</strong></p>
</td>
<td width="38.1200%">
<p><strong>收集个人信息</strong></p>
</td>
<td width="21.7000%">
<p><strong>动态申请的权限</strong></p>
</td>
</tr>
<tr>
<td width="17.3800%">
<p>登录/注册</p>
</td>
<td width="22.7600%">
<p>登录/注册</p>
</td>
<td width="38.1200%">
<p>手机号码、短信验证码</p>
</td>
<td width="21.7000%">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="17.3800%">
<p>认证</p>
</td>
<td width="22.7600%">
<p>实名制认证管理</p>
</td>
<td width="38.1200%">
<p>姓名、机构名称、部门、职位、所在省市、邮箱、名片或工牌工作证明照片</p>
</td>
<td width="21.7000%">
<p>相机权限</p>
</td>
</tr>
<tr>
<td width="17.3800%">
<p>意向咨询</p>
</td>
<td width="22.7600%">
<p>意向咨询</p>
</td>
<td width="38.1200%">
<p>机构名称、联系人、所在省市</p>
</td>
<td width="21.7000%">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="17.3800%">
<p>场外衍生品服务</p>
</td>
<td width="22.7600%">
<p>登录场外衍生品账号</p>
</td>
<td width="38.1200%">
<p>场外衍生品交易对手号、密码</p>
</td>
<td width="21.7000%">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="17.3800%">
<p>算法服务</p>
</td>
<td width="22.7600%">
<p>算法服务-立即体验</p>
</td>
<td width="38.1200%">
<p>资金账号、密码</p>
</td>
<td width="21.7000%">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="17.3800%">
<p>信用专区</p>
</td>
<td width="22.7600%">
<p>信用专区-登录</p>
</td>
<td width="38.1200%">
<p>信用资金账号、密码</p>
</td>
<td width="21.7000%">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="17.3800%">
<p>资产托管</p>
</td>
<td width="22.7600%">
<p>资产托管-登录管理人服务平台</p>
</td>
<td width="38.1200%">
<p>管理人平台账号、密码、短信验证码</p>
</td>
<td width="21.7000%">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="17.3800%">
<p>股权激励</p>
</td>
<td width="22.7600%">
<p>金服宝盘股</p>
</td>
<td width="38.1200%">
<p>手机号码、企业信息</p>
</td>
<td width="21.7000%">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="17.3800%">
<p>金融产品</p>
</td>
<td width="22.7600%">
<p>资金账号登录</p>
</td>
<td width="38.1200%">
<p>资金账号、密码</p>
</td>
<td width="21.7000%">
<p>&nbsp;</p>
</td>
</tr>
</tbody>
</table>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">二、用户网络身份标识信息</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">主体账号信息</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用目的：登录、用户设备识别</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用场景：唯一设备识别码、硬件序列号、IDFV、IDFA、IMSI、MEID、Android_id、未知信息、完全的网络访问权限</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">网络地址</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用目的：网络请求、安全风控</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用场景：账号安全风控、网络请求访问</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">四、设备属性信息</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">唯一设备识别码</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用目的：安全风控、故障排查、兼容适配</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用场景：设备安全风控、兼容性问题分析、性能分析</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">设备型号</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用目的：安全风控、故障排查、兼容适配</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用场景：设备安全风控、兼容性问题分析、性能分析</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">日志信息</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">操作日志</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用目的：故障排除</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用场景：根据上报的错误信息排除错误</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">附录2、《APP系统权限和使用清单》</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">1.为保障财运亨通APP能实现安全稳定运行之目的，我们可能会申请或使用操作系统的相关权限；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">2.为保障您的知情权，我们通过下列列表将产品可能申请、使用的相关操作系统权限进行展示，您可以根据实际需要对相关权限进行管理；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">3.根据产品的升级，申请、使用权限的类型与目的可能会有变动，我们将及时根据这些变动对列表进行调整，以确保您及时获悉权限的申请与使用情况；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">4.请您知悉，我们为业务与产品的功能与安全需要，我们可能也会使用第三方SDK，这些第三方也可能会申请或使用相关操作系统权限；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">5.在使用产品的过程中，您可能会使用第三方开发的H5页面，这些第三方开发的插件也可能因业务功能所必需而申请或使用相关操作系统权限；</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">一、安卓操作系统应用权限列表</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">1.读取SD卡中的内容（读取存储空间/照片权限）android.permission.READ_EXTERNAL_STORAGE</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">权限功能说明：提供读取手机储存空间内数据的功能</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用场景与目的：允许App读取存储中的图片、文件内容，在本地记录崩溃日志信息功能</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">2.修改/删除SD卡中的内容（修改/删除/存储空间/照片权限）android.permission.WRITE_EXTERNAL_STORAGE</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">权限功能说明：提供写入外部储存功能</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用场景与目的：允许App写入/下载/保存/缓存/修改/删除图片、文件、崩溃日志信息</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">3.读取手机状态和身份（电话权限、设备权限）android.permission.READ_PHONE_STATE</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">权限功能说明：提供读取手机设备标识信息，请您放心该权限无法监听、获取您的任何通话内容与信息</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用场景与目的：读取设备标识信息，识别设备ID，用于完成账号登录、安全保障功能</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">4.访问大致地理位置信息 android.permission.ACCESS_COARSE_LOCATION</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">权限功能说明：通过网络位置信息（基站和WLAN）获取大致地理位置信息</p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;">使用场景与目的：用于完成安全保障服务及基于地理位置的服务（LBS）如：同城信息、发布作品坐标定位以及小程序需使用相关位置服务功能</p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;"><strong>&nbsp;</strong></p>
<p style="font-weight: 400;">5.访问精确地理位置信息 android.permission.ACCESS_FINE_LOCATION</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">权限功能说明：通过全球定位系统（GPS）和网络位置信息（基站和WLAN）获取精准地理位置信息</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用场景与目的：用于完成安全保障服务及基于地理位置的服务（LBS）如：同城信息、发布作品坐标定位以及小程序需使用相关位置服务功能</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">6.访问手机摄像头 android.Manifest.permission.CAMERA</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">权限功能说明：使用摄像头</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用场景与目的：用于帮助您完成拍照上传认证文件或扫描二维码需要使用该权限的相关功能。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">7.访问手机传感器信息</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">传感器信息说明：获取当前终端环境是否存在光线传感器。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用场景与目的：用于帮助您判断目前操作环境是否为模拟器操作环境，及时进行安全操作环境提示。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">8.访问手机wifi状态 android.permission.ACCESS_WIFI_STATE</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">权限功能说明：获取当前终端是否连接到wifi网络。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用场景与目的：用于您在观看视频时进行相关注意流量使用的提示信息。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">9.申请安装应用程序包android.permission.REQUEST_INSTALL_PACKAGES</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">权限功能说明：申请安装应用程序包。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用场景与目的：用于您在更新程序后进行自动安装的申请操作，方便用户快速升级到最新版本。</p>
<p style="font-weight: 400;">&nbsp;</p>
<ol start="10">
<li>查看网络状态权限</li>
</ol>
<p style="font-weight: 400;">android.permission.ACCESS_NETWORK_STATE</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">权限功能说明：播放视频内容时提示用户使用流量播放。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用场景与目的：播放视频或者直播时，根据网络状态提醒用户具体网络状态，方便用户确认手机流量使用情况。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">二、iOS操作系统应用权限列表</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">1.NSPhotoLibraryAddUsageDescription</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">权限功能说明：向相册中添加内容</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用场景和目的：允许App写入/下载/保存/修改/删除图片、文件、崩溃日志信息</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">2.NSPhotoLibraryUsageDescription</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">权限功能说明：读取相册中内容</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用场景和目的：允许App读取存储中的图片、文件内容，主要用于帮助您在账户认证过程中上传各类证件照片时使用。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">3.NSCameraUsageDescription</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">权限功能说明：使用摄像头</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用场景和目的：用于帮助您完成拍照上传认证文件或扫描二维码需要使用该权限的相关功能。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">4.NSLocationWhenInUseUsageDescription</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">权限功能说明：仅App被使用时获取地理位置</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用场景和目的：用于完成安全保障、最近营业部推荐基于地理位置服务（LBS）相关功能</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">5.NSUserTrackingUsageDescription</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">权限功能说明：获取设备标识，以识别设备</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用场景和目的：仅用于标识设备，保障服务安全。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">6.NSLocationTemporaryUsageDescriptionDictionary</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">权限功能说明：允许临时访问精确地理位置信息</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用场景和目的：用于完成安全保障、最近营业部推荐基于地理位置服务（LBS）相关功能</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">7.读取设备IDFA、IDFV标识</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">权限功能说明：获取设备IDFA和IDFV标识设备</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用场景和目的：仅用于标识设备，用于保障用户服务安全以及设备异常信息记录。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">8.读取设备剪切板</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">权限功能说明：获取设备剪切板数据</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">使用场景和目的：用于通过剪贴板字符串内容，唤起APP相关资讯和服务页面的场景。</p>
<p style="font-weight: 400;">&nbsp;</p>
<p style="font-weight: 400;">&nbsp;</p>

  </div>
</template>

<script>
document.title = "财运亨通隐私政策";
export default {
  name: "QctServiceProtocal",
  mounted: function () {
    // sensors.track('qctPrivateProtocal', Object.assign({}, {
    //   platform_type: 'H5',
    //   platform_name: '',
    //   client_id: 'aaa'
    // }, {}))
  },
  data: function () {
    return {
      // uaInfo: "",
    };
  },
};
</script>

<style scoped>
.content {
  padding: 100px;
}

p {
  word-break: break-all;
}
</style>